<div class="modal-header">
    <h4 class="modal-title">Actualizar Tipo de Gasto</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-12 mb-3">
                <label for="nombre">Nombre</label>
                <input class="form-control" type="text" formControlName="nombre"
                [ngClass]="{'is-invalid': form.controls['nombre'].errors && form.controls['nombre'].touched}">
            </div>
            <div class="col-12 mb-3">
                <label for="descripcion">Descripción</label><label class="campo-opcional">(Opcional)</label>
                <textarea class="form-control" rows="3" formControlName="descripcion"
                    [ngClass]="{'is-invalid': form.controls['descripcion'].errors && form.controls['descripcion'].touched}"></textarea>
            </div>
        </div>
    
    </form>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="guardar()">Actualizar</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.close('Close click')">Cerrar</button>
</div>